import { render, staticRenderFns } from "./MagTemplateLayout.vue?vue&type=template&id=cf37c97c&scoped=true&"
import script from "./MagTemplateLayout.vue?vue&type=script&lang=js&"
export * from "./MagTemplateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf37c97c",
  null
  
)

export default component.exports